// extracted by mini-css-extract-plugin
export var details = "_ee-0";
export var inspectorPopover = "_ee-1";